import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment as ENV } from '../../../environments/environment';
import { URL_MAP } from '../../shared/urlMap';

import { RadicarSolicitudRequest } from '../../models/radicar-solicitud/radicar-solicitud-request';
import { RadicarSolicitudResponse } from '../../models/radicar-solicitud/radicar-solicitud-response';

@Injectable({
  providedIn: 'root',
})
export class RadicarSolicitudService {
  private apiUrl = `${ENV.HOST}${URL_MAP.API.RADICAR_SOLICITUD}`;

  constructor(private http: HttpClient) {}

  radicarSolicitud(
    request: RadicarSolicitudRequest,
  ): Observable<RadicarSolicitudResponse> {
    return this.http.post<RadicarSolicitudResponse>(this.apiUrl, request);
  }
}
